// extracted by mini-css-extract-plugin
module.exports = {"example_label":"mFyGw6-BPyWPOvwl3ehht"};